export default {"src":"/_next/static/media/pattern-background.e6a17e51.svg","height":192,"width":192,"blurWidth":0,"blurHeight":0};